import { render, staticRenderFns } from "./PSelectKeyValue.vue?vue&type=template&id=667fafdb&"
import script from "./PSelectKeyValue.vue?vue&type=script&lang=js&"
export * from "./PSelectKeyValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports